import {  TextField } from '@material-ui/core'
import React, {  useCallback, useEffect } from 'react'
import {  mdiMicrosoftExcel, mdiFilePdfBox, mdiMagnify } from '@mdi/js'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../store/hooks'
import TableListarLogUser  from './Components/TableListarLogUser'
import Section, { SectionBox, SectionOption } from '../../../../components/Section'
import get from './Scripts/get'
import { setFieldDtFim, setFieldDtInicio, setFieldFiltered, setFieldFilteredTabela } from './Reducers/logUserReducer'
import { Link, useParams } from 'react-router-dom'
import filter from './Scripts/filter'
import { defaultRelatorioExcel } from '../../../../scripts/defaultRelatorioExcel'
import {  Select as SelectMUI, MenuItem } from '@material-ui/core'
import { arrayTabelas } from '../../../../constants/tabelas'


const LogUser: React.FC = () => {

    const dispatch = useDispatch()
    const { listaLogs, requestGet, requestSave, requestEdit, requestRemove, fieldFiltered, filteredListaLogs, fieldDtInicio, requestFilter, fieldDtFim, fieldFilteredTabela } = useAppSelector(state => state.logUserReducer)


    const API_CONTROLLER = "logUser"
    const PAGE_NAME = "Log de Usuários"
    const SHOW_TABLE = !!listaLogs
    const SHOW_FILTERED = SHOW_TABLE && !!filteredListaLogs
    const { idCliente } = useParams<any>()
    
    useEffect(() => {
        
        (async () => { await filter(API_CONTROLLER, dispatch, {descricao: fieldFiltered, dtPesquisa:fieldDtInicio, fim:fieldDtFim, tabela: fieldFilteredTabela}, idCliente)})()
    }, [dispatch, idCliente])  

    const handleFilter = useCallback(async () => {
        await filter(API_CONTROLLER, dispatch, {descricao: fieldFiltered, dtPesquisa:fieldDtInicio, fim:fieldDtFim, tabela: fieldFilteredTabela}, idCliente)
    }, [dispatch, fieldFiltered, fieldDtInicio, fieldDtFim, fieldFilteredTabela, idCliente])


    return (
        <>
            <Section name = "NameSection">
                <SectionBox 
                    title = {PAGE_NAME}
                    padding = {false} 
                    right = {
                        <>
                           <TextField id="filterDescricao" variant="standard" className="fieldFilter" placeholder="Descrição" value={fieldFiltered} onChange={e => dispatch(setFieldFiltered(e.target.value as string))}  />
                           <TextField title='inicio'  id="Inicio"  type={"date"} className="fieldFilter" placeholder="Inicio"  defaultValue={fieldDtInicio} onChange={(e)=> dispatch(setFieldDtInicio(e.target.value as string))}  />
                           <TextField title='inicio' style={{marginRight:"30px"}} id="Inicio"  type={"date"} className="fieldFilter" placeholder="Inicio"  defaultValue={fieldDtFim} onChange={(e)=> dispatch(setFieldDtFim(e.target.value as string))}  />
                            <SelectMUI  id="filterAtivo" value={fieldFilteredTabela} onChange={e => dispatch(setFieldFilteredTabela(e.target.value as any))}>
                            <MenuItem selected={true} value={'null'}>Todos</MenuItem>
                                {arrayTabelas.map((field, index) => <MenuItem value={field.id}>{field.descricao}</MenuItem>)}

                            </SelectMUI> 
                           
                           <SectionOption icon = {mdiMagnify} tooltip = "Filtrar" onClick = {handleFilter} />
                           {/* <Link to = "pdf" target = "_blank">
                                <SectionOption icon = {mdiFilePdfBox} tooltip = "Visualizar PDF" onClick = {() => {}} />
                            </Link> */}
                            <SectionOption icon = {mdiMicrosoftExcel} tooltip = "Salvar excel" onClick = {() => defaultRelatorioExcel(filteredListaLogs??[], "Log_usuario")} />
                        </>
                    }
                >
                    <TableListarLogUser 
                        lista={filteredListaLogs} 
                        loading = {requestGet.loading || requestFilter.loading} 
                    />
                </SectionBox>
            </Section>
            <>  




            </>
        </>
    )
}

export default LogUser
